import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CruiseService } from '../../services/cruise.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-homeFooter',
  templateUrl: './homeFooter.component.html',
  styleUrls: ['./homeFooter.component.css']
})
export class HomeFooterComponent {
  title = 'Cruize';
  subscription: any = {
    name: "",
    email: ""
  };
  name: string = ""; email = ""; public loginType = '';
  mobile: string = "";

  constructor(private route: ActivatedRoute, private routr: Router, private cruiserService: CruiseService, private toastr: ToastrService) {
    this.loginType = this.cruiserService.getloginType();
  }

  subscribe() {
    console.log(this.name);
    if (this.name == "") {
      this.toastr.warning("Name is required...!");
      return false;
    }
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if (this.email == "") {
      this.toastr.warning("Email is required...!");
      return false;
    }
    if (!emailReg.test(this.email)) {
      this.toastr.warning("Please provide Correct Email...!");
      return false;
    }

    this.cruiserService.subscribe(this.name, this.email).subscribe(
      data => {
        this.toastr.success("Request Submitted successfully...!");
      },
      error => {
        this.toastr.error("Something went wrong...!")
      }
    )
  }

  sendLinkToMobile() {
    console.log(this.mobile);
    if (this.mobile == "") {
      this.toastr.warning("Mobile is required...!");
      return false;
    }

    this.cruiserService.applink(this.mobile).subscribe(
      data => {
        this.toastr.success("Request Submitted successfully...!");
      },
      error => {
        this.toastr.error("Something went wrong...!")
      }
    )
  }
}
